import React from 'react'

import { Button, Popup } from 'semantic-ui-react'

export default function SaveAndPublishButton({
  onSavingFeedbackWidgetSettings,
  isSaveFeedbackWidgetSettingsLoading,
  disallowSavingCustomCSS,
  className,
  setHasWidgetFormUnsavedChange,
}: SaveAndPublishButtonPropType) {
  if (disallowSavingCustomCSS) {
    return (
      <Popup
        basic
        wide
        trigger={
          <div className={className}>
            <Button primary disabled>
              Save and publish
            </Button>
          </div>
        }
      >
        Please remove custom CSS or upgrade to Pro before saving.
      </Popup>
    )
  }

  return (
    <Button
      primary
      className={className}
      onClick={() => {
        onSavingFeedbackWidgetSettings()
        setHasWidgetFormUnsavedChange(false)
      }}
      disabled={isSaveFeedbackWidgetSettingsLoading}
      loading={isSaveFeedbackWidgetSettingsLoading}
    >
      Save and publish
    </Button>
  )
}

type SaveAndPublishButtonPropType = {
  onSavingFeedbackWidgetSettings: () => void
  isSaveFeedbackWidgetSettingsLoading: boolean
  disallowSavingCustomCSS: boolean
  className: string
  setHasWidgetFormUnsavedChange: Function
}



// WEBPACK FOOTER //
// ./src/components/Admin/FeedbackWidgetSettings/SaveAndPublishButton.tsx